import ProficiencyGroups from './ProficiencyGroups';

export default ProficiencyGroups;
export { ProficiencyGroups };
